<template>
    <div class="row_center_center fixed inset-0" style="background-color: rgba(0, 0, 0, 0.9);">
        <div class="column_center_start popup_body">
            <div class="w-full row_center_center">
                <text class="text-xl font-semibold my-6">請選擇桌號</text>
            </div>
            <div class="scroll_flex_container" style="flex-grow: 1; width: 100%; background-color: #fff;">
                <div class="column_start_start table_option mb-2.5" v-for="(item, index) in tableOptions" :key="index" @click="item.tables.length ? null : setTable(item)">
                    <text class="text-base font-regular mb-2" v-if="item.name" >{{ item.name }}</text>
                    <div class="grid w-full grid-cols-2 gap-1.5" v-if="item.tables.length">
                        <div class="row_center_center border border-[#AAAAAA] w-full shrink-0 h-11 rounded-md"
                            v-for="(table, tableIndex) in item.tables" :key="tableIndex" @click="setTableNumber(item, table)">
                            <button class="font-normal">{{ table.name }}</button>
                        </div>
                    </div>
                </div>
            </div>
            <button class="cancel_button" @click="$emit('close')">取消</button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        tableOptions: {
            type: Array,
            default: () => [],
            required: true,
        },
    },
    methods: {
        setTableNumber(item, table) {
            console.log('選擇桌號', item, table)
            const tableName = `${item.name}${table.name}`
            const data = {
                tableName,
                areaId: item.areaId,
                tableIndex: item.tables.findIndex(el => el.name === table.name)
            }
            console.log('data', data)
            this.$store.commit('cart/setTableData', data)
            this.$emit('close')
        },
        setTable(item) {
            console.log('選擇桌', item)
            const data = {
                tableName: item.name,
                areaId: item.areaId,
                tableIndex: -1
            }
            console.log('data', data)
            this.$store.commit('cart/setTableData', data)
            this.$emit('close')
        }
    }
}
</script>
<style lang="scss">
.popup_body {
    width: 80%;
    height: 90%;
    background-color: #fff;
    border-radius: 6px;
    padding-top: 10px;
}

.table_option {
    width: 80%;
}

.cancel_button {
    width: 100%;
    height: 56px;
    border: none;
    font-size: 20px;
    font-weight: 500;
    font-family: PingFang SC;
    color: #000;
    border-radius: 8px;
    background-color: #EEEEEE;
    flex-shrink: 0;
}
</style>